var map = {
	"./gato.png": 8312,
	"./img10.png": 9188,
	"./img11.png": 4980,
	"./img12.png": 2900,
	"./img13.png": 5012,
	"./img14.jpg": 3636,
	"./img15.jpg": 8480,
	"./img7.png": 720,
	"./img8.png": 8544,
	"./img9.png": 4500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3800;